module.exports = "sup {\n  left: -0.6em; }\n"